import { PortalSettingsActionTypes, FetchPortalSetting } from '../actions/PortalSettingsActions';
import { getFetchPortalSettingRequestStatus } from '../selectors/RequestStatusSelector';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import PortalSettingsAPI from '../api/PortalSettingsAPI';
import requestEntity from './requestEntity';
import RequestEpicDescriptor from './RequestEpicDescriptor';
const fetchPortalSetting = requestEntity(new RequestEpicDescriptor({
  apiFunction: PortalSettingsAPI.getPortalSetting,
  initiatingActionType: PortalSettingsActionTypes.LOAD_PORTAL_SETTING,
  requestStatusSelector: getFetchPortalSettingRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED],
  requestActions: FetchPortalSetting
}));
export default fetchPortalSetting;